import { useEffect, useState } from 'react';
import { type MediaHandlerProps, useMediaUtils } from '..';

/**
 *
 * By default we want to push a play event after 3 seconds of the iframe being loaded.
 */
export const useDefaultHandler = ({ eventName }: MediaHandlerProps) => {
  const [state, setState] = useState({
    timedOut: false,
  });

  const { isFirstPlay, push } = useMediaUtils(eventName);

  useEffect(() => {
    if (state?.timedOut === false) return;
    if (isFirstPlay.current === true) return;

    isFirstPlay.current = true;
    push('play');
  }, [state]);

  const onLoad = () => {
    setTimeout(() => {
      if (!state?.timedOut) setState({ ...state, timedOut: true });
    }, 3000);
  };

  return {
    onLoad,
  };
};
